import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../../CommonUtils/CommonFormHeading';
import Swal from 'sweetalert2';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios';
import { failureAlert } from '../../../CommonUtils/SweetAlerts';
import { config } from '../../../CommonUtils/CommonURLS';
import { viewImage } from '../../../CommonUtils/viewImage';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaFilePdf } from 'react-icons/fa';


export default function AfflProceedDeclaration({ onNext, prograssvalue }) {
    const location = useLocation();
    let Type = location?.state?.type || "";
    const hasFetchedData = useRef(false);
    const acYear = sessionStorage.getItem('ac_year')
    const CollegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);

    const navigate = useNavigate();

    const ProeedDeclareFormik = useFormik({
        initialValues: {
            cdcDskToVc: '',
            cdcDskUndertaking: '',
            acYear: acYear,
            collCode: CollegeCode,
        },
        onSubmit: (values) => {
            if (values?.cdcDskUndertaking === "" || values?.cdcDskUndertaking === null || values?.cdcDskUndertaking === undefined || values?.cdcDskUndertaking === false) {
                return Swal.fire("Accept all the terms and conditions", "", "warning")
            }
            if (values?.cdcDskToVc === "" || values?.cdcDskToVc === null || values?.cdcDskToVc === undefined || values?.cdcDskToVc === false) {
                return Swal.fire("Accept all the terms and conditions", "", "warning")
            }

            else {
                Swal.fire({
                    text: 'Are you sure you want to submit?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, submit it!',
                    cancelButtonText: 'No, cancel!',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const url = `${config.url.API_URL}saveCdcPdf`;
                        CommonAxiosPost(url, values).then((res) => {
                            if (res?.data?.Status === true) {
                                Swal.fire({
                                    title: res?.data?.sdesc,
                                    backdrop: false
                                }).then((response) => {
                                    if (response?.isConfirmed === true) {
                                        GetCourseStatus();
                                        prograssvalue(100);
                                        if (Type === "NONOAMDC") { navigate("/Affl_CdcReport2022"); }
                                        else
                                            navigate("/Affl_CdcOamdcReport2023");
                                    }
                                });
                            } else {
                                failureAlert(res?.data?.sdesc);
                            }
                        });
                    } else {
                        console.log('Submission canceled');
                    }
                });
            }
        },
    })
    const [DeanName, setDeanName] = useState([]);
    const [CourseStatus, SetCourseStatus] = useState([]);
    function GetDeanName() {
        let url = config.url.API_URL + `getDeanName`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setDeanName(res?.data?.dean)
            } else {
                setDeanName([])
            }
        })
    }
    function GetCourseStatus() {
        let url = config.url.API_URL + `coursesStatus/` + CollegeCode + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                SetCourseStatus(res?.data?.status[0])
                ProeedDeclareFormik?.setFieldValue("cdcDskUndertaking", res?.data?.status[0]?.cdc_dsk_undertaking ?? '');
                ProeedDeclareFormik?.setFieldValue("cdcDskToVc", res?.data?.status[0]?.cdc_dsk_to_vc ?? '');

            } else {
                SetCourseStatus([])
            }
        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetDeanName();
            GetCourseStatus();
            hasFetchedData.current = true
        }

    }, [])
    return (
        <>

            <CommonFormHeading heading="Certification of accuracy of Details" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={ProeedDeclareFormik}>
                    <Form onChange={ProeedDeclareFormik?.handleChange} onSubmit={ProeedDeclareFormik?.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3">
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                    <bie.Alert className='affl-alert' variant='danger'>
                                        <bie.FormGroup>
                                            <Field type="checkbox" name="cdcDskUndertaking" />
                                            <ErrorMessage name="cdcDskUndertaking" component="div" className="text-error" />

                                            <span style={{ marginLeft: '10px' }}>
                                                I hereby certify that I have examined all the necessary records and documents pertaining to this college that are essential
                                                in processing the Application of the college for grant of Affiliation with the University, and the details submitted are correct and accurate.
                                            </span>

                                        </bie.FormGroup>
                                        <bie.FormGroup>
                                            <Field type="checkbox" name="cdcDskToVc" />
                                            <ErrorMessage name="cdcDskToVc" component="div" className="text-error" />

                                            <span style={{ marginLeft: '10px' }}>
                                                I hereby submit this information to the Vice-Chancellor/Registrar of the University for favour of kind information and necessary orders in this regard.
                                            </span>

                                        </bie.FormGroup>
                                    </bie.Alert>
                                </bie.Col>
                            </bie.Row>
                            <bie.Row className='justify-content-end'>

                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={3} className=''>
                                    Sd/- <br />
                                    <b>{DeanName} </b><br />
                                    Dean-College Development Council

                                </bie.Col>
                                {CourseStatus?.cdc_file_path ? (
                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={3} xxl={3}>

                                        <button type="button" className="btn btn  btn-md pt-1"
                                            onClick={() => { viewImage(CourseStatus?.cdc_file_path); }}>
                                            <FaFilePdf color="red"
                                                size={20} /> View Pdf
                                        </button>
                                    </bie.Col>
                                ) : (
                                    <div className="button-cend pt-1 mb-3 ">
                                        <button type="submit" className="btn btn-success mt-2 float-end mb-2" >
                                            Submit
                                        </button>
                                    </div>
                                )}
                            </bie.Row>
                            <bie.Row>


                            </bie.Row>


                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}
